/**
 * `/login?next=…`: where sign-in continues instead of `/home`. Only the OAuth
 * consent page, only on this origin — anything else would be an open redirect.
 */

const ALLOWED_NEXT_PATHNAMES: readonly string[] = ["/oauth/authorize"];

export function safeLoginNextPath(
  raw: string | string[] | null | undefined,
): string | null {
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (!value?.startsWith("/") || value.startsWith("//") || value.includes("\\")) {
    return null;
  }
  const pathname = value.split(/[?#]/)[0] ?? "";
  return ALLOWED_NEXT_PATHNAMES.includes(pathname) ? value : null;
}
